module.exports = __webpack_public_path__ + "static/media/Milk_lite2.a3454644.jpg";